import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Logo from '~/components/Logo';
import Button from '~/components/Button';
import { NAV_LINKS } from '~/data/site';
import { useAuth } from '~/lib/auth';
import s from './Nav.module.scss';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const profile = useAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`${s.nav} ${scrolled || open ? s.scrolled : ''}`}>
      <div className={s.inner}>
        <Link to="/" className={s.brand} onClick={() => setOpen(false)}>
          <Logo />
        </Link>

        <nav className={`${s.links} ${open ? s.open : ''}`}>
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              className={({ isActive }) => `${s.link} ${isActive ? s.active : ''}`}
              onClick={() => setOpen(false)}
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink
            to={profile ? '/account' : '/login'}
            className={({ isActive }) => `${s.link} ${isActive ? s.active : ''}`}
            onClick={() => setOpen(false)}
          >
            {profile ? 'Account' : 'Sign in'}
          </NavLink>
          {!profile && (
            <Button to="/pricing" className={s.cta}>
              Get API access
            </Button>
          )}
        </nav>

        <button
          className={`${s.burger} ${open ? s.burgerOpen : ''}`}
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
